import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import Logout from 'pages/Authentication/Logout';
import { useUnifiedAuth } from 'components/Common/UnifiedAuthContext';


export default function UserSettings() {
  const { user } = useUnifiedAuth();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Tooltip title='Open settings'>
      <>
        <IconButton sx={{ p: 0 }} onClick={handleClick}>
          <Avatar
            alt={user?.name}
            imgProps={{ referrerPolicy: 'no-referrer' }}
            src={user?.picture}
          />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          keepMounted
          onClose={handleClose}
          onClick={handleClose}
          sx={{
            textTransform: 'none',
          }}
        >
          <Logout />
        </Menu>
      </>
    </Tooltip>
  );
}
